import {
    GET_REDEEM_COIN,
    GET_REDEEM_COINS,
    SET_ALL_REDEEM_COIN,
    SET_ALL_REDEEM_COIN_SELECT
  } from "../../reducerTypes";
  
  const initialState = {
    getTitleList: [],
    getData: {},
    getList: [],
    selectData: [],
  };
  
  const RedeemCoinReducer = (state = initialState, action) => {
    switch (action.type) {
     
      case SET_ALL_REDEEM_COIN:
        return {
          ...state,
          getList: action.payload,
        };
      case GET_REDEEM_COINS:
        return {
          ...state,
          getList: action.payload,
        };
      case SET_ALL_REDEEM_COIN_SELECT:
        const contentData = action.payload ? action.payload : [];
        const selectData = [];
        contentData.map((data) => {
          selectData.push({
            value: data.id,
            label: `${data.title}`,
            labelEn: `${data.titleEn}`,
            price: data.price,
          });
        });
        return {
          ...state,
          selectData: selectData,
        };
      case GET_REDEEM_COIN:
        return {
          ...state,
          getData: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default RedeemCoinReducer;
  